import React from "react";

export default function PersonalData() {
  return <div>PersonalData</div>;
}
